<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="车牌号码" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.carNumberplate" placeholder="请输入车牌号码">
						</el-input>
					</el-form-item>
					<el-form-item label="车型" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.carType" placeholder="请输入车型">
						</el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status" class="big" placeholder="请选择状态" clear>
							<el-option :key="0" label="未启用" :value="0">未启用</el-option>
							<el-option :key="1" label="正常" :value="1">正常</el-option>
							<el-option :key="2" label="在途" :value="2">在途</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="是否为挂靠车辆" class='tiny'>
						<el-select v-model="orderInfo.isJoinCar" class="big" placeholder="请选择" clear>
							<el-option :key="0" label="自有车辆" :value="0">自有车辆</el-option>
							<el-option :key="1" label="挂靠车辆" :value="1">挂靠车辆</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
		<!-- 	<el-table-column prop="id" label="编号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column> -->
			
			<el-table-column prop="carNumberplate" label="车牌号码" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			
		
			<el-table-column prop="isJoinCar" label="是否挂靠车辆" align="center" :show-overflow-tooltip="true">

				<template slot-scope="scope">
					<span v-if="scope.row.isJoinCar==1">挂靠车辆</span>
					<span v-if="scope.row.isJoinCar==0">自有车辆</span>

				</template>
			</el-table-column>
			<el-table-column prop="carType" label="车型" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="carImages" label="车辆照片" align="center" :show-overflow-tooltip="true">
			
				<template slot-scope="scope">
					<span @click="lookzj(scope.row.carImages)">查看</span>
					
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
			
				<template slot-scope="scope">
					<span v-if="scope.row.status==0">未启用</span>
					<span v-if="scope.row.status==1">正常</span>
					<span v-if="scope.row.status==2">在途</span>
			
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose"
			:close-on-click-modal="false"  width="600px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="车牌号码" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.carNumberplate"
							auto-complete="off" placeholder="请输入车牌号码" />
					</el-form-item>
					<el-form-item label="是否为挂靠车辆" label-width="120px">
						<el-select v-model="storeGoodsInfo.isJoinCar"  placeholder="请选择" clear style="width: 300px;">
							<el-option :key="0" label="自有车辆" :value="0">自有车辆</el-option>
							<el-option :key="1" label="挂靠车辆" :value="1">挂靠车辆</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="车型" label-width="120px">
						<el-input type="text" style="width: 300px;" v-model="storeGoodsInfo.carType"
							auto-complete="off" placeholder="请输入车型,例：17.5米平板车" />
					</el-form-item>
					<el-form-item label="状态" label-width="120px">
						<el-select v-model="storeGoodsInfo.status" placeholder="请选择" clear style="width: 300px;">
							<el-option :key="0" label="未启用" :value="0">未启用</el-option>
							<el-option :key="1" label="正常" :value="1">正常</el-option>
							<el-option :key="2" label="在途" :value="2">在途</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="车辆照片" label-width="120px" >
						<br />
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
							:on-success="onSuccess">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					
					
					<el-button type="primary" v-if="title=='添加车辆'" @click="submit">新增</el-button>
					<el-button type="primary" v-else @click="submitClick">提交</el-button>

				</el-form>
			</div>
		</el-dialog>
		
		<el-dialog :visible.sync="dialogVisibleImg" style="float:rigin;height: 100%;" :closeOnClickModal="false">
			<el-carousel indicator-position="outside" style="height: 600px;">
				<el-carousel-item v-for="(item,index) in dialogImageUrl" :key="index" style="height: 500px;">
					<img :src="item" style="width: 100%; height: 100%;" />
				</el-carousel-item>
			</el-carousel>
			<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	export default {
		data() {
			return {
					httpUrl: urls+'?type=2023',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				dialogImageUrl:[],
				dialogVisibleImg:false,
				title:'',
				orderInfo: {},
				sliderlist:{},
				goodsImages:[],
				storeGoodsInfo: {},
				fileList:[],
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false

			}
		},
		methods: {
			//导出
			downloadFile() {
				let data = {
					...this.orderInfo
				};
				// console.log(data);
				this.$api.cartListExportExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "车辆管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url.split(',');
				this.dialogVisibleImg = true;
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				// console.log('aaa')

				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					 ...this.orderInfo
					// name:this.orderInfo.name
				}
				this.$api.carslist(this.$encrypt(data)).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
			
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			lookzj(img){
				this.dialogImageUrl=img.split(',')
				// console.log(this.dialogImageUrl);
				this.dialogVisibleImg=true
			},
			// 新增
			addCarousel() {
				this.goodsImages=[]
				this.fileList=[]
				this.dialogVisibleSwiper = true
				this.title='添加车辆'
			},

			// 提交
			submit() {
					// console.log(this.goodsImages)
				let data = {
					...this.storeGoodsInfo,
					carImages:this.goodsImages.join(',')
				}
			
				this.$api.addcarslist(this.$encrypt(data)).then((res) => {
					
				
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.title='编辑车辆'
				this.goodsImages=''
				this.fileList=[]
				this.$api.findcarsByID(e).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeGoodsInfo = res.data
						let imagesArray = res.data.carImages.split(',')
						for (let i = 0; i < imagesArray.length; i++) {
							this.fileList.push({
								name: imagesArray[i],
								url:imagesArray[i]
							
							})
						}
						this.goodsImages=imagesArray
						// console.log(this.goodsImages.join(','));
						this.dialogVisibleSwiper = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
				// console.log();
				let data = {
					...this.storeGoodsInfo,
					carImages:this.goodsImages.join(',')
				
				}
				
				this.$api.upcarslist(this.$encrypt(data)).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该车辆, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delcarsByID(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
			},
		},




		created() {
			this.findPmsUnit()

		}
	}
</script>

<style>

</style>
